const prefix = 'DimSupplier';

export enum DimSupplierField {
  ID = `${prefix}.id`,
  NAME = `${prefix}.name`,
  WEBSITE = `${prefix}.website`,
  STATUS = `${prefix}.status`,
  DUNS = `${prefix}.duns`,
  IS_POSTING_BLOCKED = `${prefix}.isPostingBlocked`,
  IS_PURCHASING_BLOCKED = `${prefix}.isPurchasingBlocked`,
  DOMAIN_NAME = `${prefix}.domainName`,
  CREATED_AT = `${prefix}.createdAt`,
  UPDATED_AT = `${prefix}.updatedAt`,
}
